import React, { Component } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction"; // needed for dayClick
import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";
import AddIcon from "@material-ui/icons/Add";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import { useHistory } from "react-router-dom";
import { Route } from "react-router-dom";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { KeyboardDatePicker } from "@material-ui/pickers";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import FileCopyIcon from "@material-ui/icons/FileCopyOutlined";
import SaveIcon from "@material-ui/icons/Save";
import AssignmentIcon from "@material-ui/icons/AssignmentInd";
import PrintIcon from "@material-ui/icons/Print";
import ShareIcon from "@material-ui/icons/Share";
import FavoriteIcon from "@material-ui/icons/Favorite";
import ReactExport from "react-export-excel-xlsx-fix";
import "./main.scss";
import { Typography } from "@material-ui/core";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import compose from "recompose/compose";
import randomColor from "randomcolor";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";

import { CSVLink, CSVDownload } from "react-csv";

import Moment from "react-moment";

import { fetchVisits, fetchPatients, fetchAdmins } from "./actions/index";
import { fetchVisitsForExport } from "./api/visits";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const theme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#002BB8",
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      main: "#7200B8",
    },
    info: {
      main: "#3177EA",
    },
  },
});

// The range the modal opens on: the past week through tomorrow (a day of
// forward buffer so today's just-finished visits are always included).
const DEFAULT_DOWNLOAD_RANGE = () => ({
  start: moment().subtract(7, "days"),
  end: moment().add(1, "day"),
});

// Presets for the "Download Visits" modal. Each returns an inclusive
// [start, end] moment range. "This Month"/"This Year" are the calendar month and
// calendar year (not trailing windows); the "Past N Days" presets trail from
// today; "All Visits" spans everything. The modal opens on a custom default
// (DEFAULT_DOWNLOAD_RANGE), so no preset is pre-selected.
const DOWNLOAD_PRESETS = [
  {
    key: "thisMonth",
    label: "This Month",
    range: () => ({ start: moment().startOf("month"), end: moment().endOf("month") }),
  },
  {
    key: "past7",
    label: "Past 7 Days",
    range: () => ({ start: moment().subtract(7, "days"), end: moment() }),
  },
  {
    key: "past30",
    label: "Past 30 Days",
    range: () => ({ start: moment().subtract(30, "days"), end: moment() }),
  },
  {
    key: "past90",
    label: "Past 90 Days",
    range: () => ({ start: moment().subtract(90, "days"), end: moment() }),
  },
  {
    key: "thisYear",
    label: "This Year",
    range: () => ({ start: moment().startOf("year"), end: moment().endOf("year") }),
  },
  {
    // Everything on record. The start predates any clinic data; the +1 day end
    // keeps today's visits in. The export endpoint has no range cap, so this is
    // a single request.
    key: "allVisits",
    label: "All Visits",
    range: () => ({ start: moment("2000-01-01"), end: moment().add(1, "day") }),
  },
];

// const actions = [
//     {
//         icon: <ExcelFile filename="Patient Visits" element={<SaveIcon style={{ marginTop: 4 }} />}>
//             <ExcelSheet data={this.props.visits} name="Summary">
//                 <ExcelColumn label="Visit ID" value="id" />
//                 <ExcelColumn label="Patient ID" value={'patient.id'} />
//                 <ExcelColumn label="Patient Name" value={'patient.name'} />
//                 <ExcelColumn label="Date" value={'date.start'} />
//                 <ExcelColumn label="Practitioner" value={'practitioner.name'} />
//                 <ExcelColumn label="Service" value={'service[0].type'} />
//                 <ExcelColumn label="Gross Price" value={'service[0].price.gross'} />
//                 <ExcelColumn label="Tax Price" value={'service[0].price.tax'} />
//                 <ExcelColumn label="Net Price" value={'service[0].price.net'} />
//                 <ExcelColumn label="Paid"
//                     value={(col) => col.service[0].paid ? "True" : "False"} />
//                 <ExcelColumn label="Invoice"
//                     value={(col) => col.service[0].invoice.yn ? "True" : "False"} />
//             </ExcelSheet>

//         </ExcelFile>, name: 'Download XSLX'
//     },
//     { icon: <AddIcon />, name: 'New Patient' },
// ];

const styles = (theme) => ({
  root: {
    width: "100%",
    maxWidth: 500,
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  dense: {
    marginTop: 16,
  },
  menu: {
    width: 200,
  },
  exampleWrapper: {
    position: "relative",
    marginTop: theme.spacing(3),
    height: 380,
  },
  radioGroup: {
    margin: theme.spacing(1, 0),
  },
  speedDial: {
    position: "fixed",
    "&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft": {
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    "&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight": {
      top: theme.spacing(2),
      left: theme.spacing(2),
    },
  },
  rootDial: {
    transform: "translateZ(0px)",
    flexGrow: 1,
  },
});

class Patients extends Component {
  csvLink = React.createRef();
  ExcelLink = React.createRef();
  ExcelLinkPayroll = React.createRef();

  constructor(props) {
    super(props);
    this.classes = props;
    this.state = {
      downloadReady: false,
      downloadPayrollReady: false,
      open: false,
      // "Download Visits" date-range modal. Opens on the default range with no
      // preset highlighted.
      downloadModalOpen: false,
      selectedPreset: "custom",
      rangeStart: DEFAULT_DOWNLOAD_RANGE().start,
      rangeEnd: DEFAULT_DOWNLOAD_RANGE().end,
      previewVisits: [],
      previewCount: 0,
      previewError: null,
      search: null,
      patients: this.props.patients,
      visits: this.props.visits,
      sheet: [],
      acupunctureSheet: [],
      osteopathySheet: [],
      massageSheet: [],
      herbsSheet: [],
      productsSheet: [],
      otherSheet: [],
      actions: [],
      columns: [
        "Visit ID",
        "Patient ID",
        "Patient Name",
        "Date",
        "Practitioner",
        "Service",
        "Price Gross",
        "Price Tax",
        "Price Net",
        "Paid?",
        "Invoice?",
      ],
      columnsPat: ["First Name", "Last Name", "Phone", "Email"],
      // Yes - this is not a great solution, but the excel converter has trouble dealing
      //  with deeply nested state, so a single payroll state to dynamically map admins won't work.
      payroll_one: [["Payroll"]],
      payroll_two: [["Payroll"]],
      payroll_three: [["Payroll"]],
      payroll_four: [["Payroll"]],
      payroll_five: [["Payroll"]],
      payroll_six: [["Payroll"]],
      payroll_seven: [["Payroll"]],
      payroll_eight: [["Payroll"]],
      payroll_nine: [["Payroll"]],
      payroll_ten: [["Payroll"]],

      // payroll: [{name: "Alex Gordienko", visits: [["Payroll"]]}, {name: "Jane Dawson", visits: [["Payroll"]]}, {name: "John B", visits: [["Payroll"]]}],
      patientsCSV: [],
      counter: 0,
      colors: randomColor({
        count: 100,
        hue: "purple",
        luminosity: "light",
      }),
    };
    this.handleSearchChange = this.handleSearchChange.bind(this);
  }

  handleSearchChange = (arg) => {
    // // console.log(arg)
    this.setState({ search: arg });
    if (arg) {
      this.props.history.push("/patient/" + arg._id);
    }
  };

  checkIfComplete = () => {};

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  getVisitData = (visits = this.props.visits) => {
    // The modal passes the range-selected visits; a bare call falls back to the
    // full loaded set. Guard against an event object arriving here (e.g. if this
    // were ever wired straight to an onClick again).
    const source = Array.isArray(visits) ? visits : this.props.visits;

    // Reset the sheets AND downloadReady: the <ExcelFile hideElement> block
    // downloads once, in its constructor, when it mounts. Flipping downloadReady
    // back to false unmounts it so the next download re-mounts and fires again —
    // otherwise a second range selection would rebuild the data but never
    // download it.
    this.setState({
      sheet: [],
      acupunctureSheet: [],
      osteopathySheet: [],
      massageSheet: [],
      herbsSheet: [],
      productsSheet: [],
      otherSheet: [],
      downloadReady: false,
    });
    // console.log("visits fired", source.length);

    var visitsClean = new Promise((resolve, reject) => {
      if (source.length === 0) {
        resolve();
        return;
      }
      source.forEach((value, index) => {
        this.visitsToExcelConversion(value);
        if (index === source.length - 1) resolve();
      });
    });

    visitsClean.then(() => {
      // console.log("All done!");
      this.setState({
        downloadReady: true,
      });
      // this.ExcelLink.click();
    });
  };

  getPractitionerWeekData = () => {
    let currentDate = moment();

    let weekStart = currentDate.clone().startOf("isoWeek");
    let weekEnd = currentDate.clone().endOf("isoWeek");

    // reset payroll array
    this.setState({
      payroll: [[["Payroll"]], [["Payroll"]], [["Payroll"]]],
      payroll_one: [["Payroll"]],
      payroll_two: [["Payroll"]],
      payroll_three: [["Payroll"]],
    });
    // console.log("visits fired", this.props.visits.length);
    var visitsPayrollClean = new Promise((resolve, reject) => {
      this.props.visits.forEach((value, index, array) => {
        // only process visits that happened between weekStart and weekEnd
        let visitDate = moment(value.date.start);
        // console.log(
        //   currentDate,
        //   weekStart.diff(visitDate),
        //   visitDate.diff(weekEnd)
        // );
        if (
          weekStart.diff(visitDate) < 0 &&
          weekEnd.diff(visitDate) > 0 &&
          !value.blocked &&
          // value.service[0].paid &&
          !value.noshow
        ) {
          console.log("this weeks event hit");
          console.log(value);
          this.visitsToPayrollExcelConversion(value);
        }
        if (index === this.props.visits.length - 1) resolve();
      });
    });

    visitsPayrollClean.then(() => {
      console.log("All done!");
      console.log(this.state.payroll_one);
      this.setState({
        downloadPayrollReady: true,
      });
      // this.ExcelLink.click();
    });
  };

  visitsToPayrollExcelConversion = (visit) => {
    // only process relevant visits
    if (
      !visit.blocked &&
      // visit.service[0].paid &&
      !visit.noshow
    ) {
      let formattedItem = [
        visit._id,
        visit.patient.id,
        visit.patient.name,
        String(visit.date.start),
        visit.service[0].practitioner.name,
        visit.service[0].type,
        visit.service[0].price.gross,
        visit.service[0].price.tax,
        visit.service[0].price.net,
        visit.service[0].paid,
        visit.service[0].invoice.yn,
      ];
      console.log("formatted item", formattedItem);
      // add array to the relevant practitioner name
      // allows for 10 admins
      if (visit.service[0].practitioner.name === this.props.admins[0].name) {
        this.setState((prevState) => ({
          payroll_one: [...prevState.payroll_one, formattedItem],
        }));
      } else if (this.props.admins[1]) {
        if (visit.service[0].practitioner.name === this.props.admins[1].name) {
          this.setState((prevState) => ({
            payroll_two: [...prevState.payroll_two, formattedItem],
          }));
        }
      } else if (this.props.admins[2]) {
        if (visit.service[0].practitioner.name === this.props.admins[2].name) {
          this.setState((prevState) => ({
            payroll_three: [...prevState.payroll_three, formattedItem],
          }));
        }
      } else if (this.props.admins[3]) {
        if (visit.service[0].practitioner.name === this.props.admins[3].name) {
          this.setState((prevState) => ({
            payroll_four: [...prevState.payroll_four, formattedItem],
          }));
        }
      } else if (this.props.admins[4]) {
        if (visit.service[0].practitioner.name === this.props.admins[4].name) {
          this.setState((prevState) => ({
            payroll_five: [...prevState.payroll_five, formattedItem],
          }));
        }
      } else if (this.props.admins[5]) {
        if (visit.service[0].practitioner.name === this.props.admins[5].name) {
          this.setState((prevState) => ({
            payroll_six: [...prevState.payroll_six, formattedItem],
          }));
        }
      } else if (this.props.admins[6]) {
        if (visit.service[0].practitioner.name === this.props.admins[6].name) {
          this.setState((prevState) => ({
            payroll_seven: [...prevState.payroll_seven, formattedItem],
          }));
        }
      } else if (this.props.admins[7]) {
        if (visit.service[0].practitioner.name === this.props.admins[7].name) {
          this.setState((prevState) => ({
            payroll_eight: [...prevState.payroll_eight, formattedItem],
          }));
        }
      } else if (this.props.admins[8]) {
        if (visit.service[0].practitioner.name === this.props.admins[8].name) {
          this.setState((prevState) => ({
            payroll_nine: [...prevState.payroll_nine, formattedItem],
          }));
        }
      } else if (this.props.admins[9]) {
        if (visit.service[0].practitioner.name === this.props.admins[9].name) {
          this.setState((prevState) => ({
            payroll_ten: [...prevState.payroll_ten, formattedItem],
          }));
        }
      }
    }
  };

  visitsToExcelConversion = (visit) => {
    // only process relevant visits
    if (!visit.blocked && visit.service[0].paid && !visit.noshow) {
      let formattedItem = [
        visit._id,
        visit.patient.id,
        visit.patient.name,
        String(visit.date.start),
        visit.service[0].practitioner.name,
        visit.service[0].type,
        visit.service[0].price.gross,
        visit.service[0].price.tax,
        visit.service[0].price.net,
        visit.service[0].paid,
        visit.service[0].invoice.yn,
      ];
      if (visit.service[0].type === "Acupuncture") {
        this.setState((prevState) => ({
          acupunctureSheet: [...prevState.acupunctureSheet, formattedItem],
        }));
      } else if (visit.service[0].type === "Osteopathy") {
        this.setState((prevState) => ({
          osteopathySheet: [...prevState.osteopathySheet, formattedItem],
        }));
      } else if (visit.service[0].type === "Massage") {
        this.setState((prevState) => ({
          massageSheet: [...prevState.massageSheet, formattedItem],
        }));
      } else if (visit.service[0].type === "Herbs") {
        this.setState((prevState) => ({
          herbsSheet: [...prevState.herbsSheet, formattedItem],
        }));
      } else if (visit.service[0].type === "Products") {
        this.setState((prevState) => ({
          productsSheet: [...prevState.productsSheet, formattedItem],
        }));
      } else {
        this.setState((prevState) => ({
          otherSheet: [...prevState.otherSheet, formattedItem],
        }));
      }
      this.setState((prevState) => ({
        sheet: [...prevState.sheet, formattedItem],
      }));
    }
  };

  getPatientData = () => {
    var patientsClean = new Promise((resolve, reject) => {
      this.props.patients.forEach((value, index, array) => {
        this.patientToCSVConversion(value);
        if (index === this.props.patients.length - 1) resolve();
      });
    });

    patientsClean.then(() => {
      // console.log("All done!");
      this.csvLink.current.link.click();
    });
  };

  patientToCSVConversion = (patient) => {
    const newelement = [
      patient.intake.general.firstName,
      patient.intake.general.lastName,
      patient.intake.general.cellPhone,
      patient.intake.general.email,
    ];
    this.setState((prevState) => ({
      patientsCSV: [...prevState.patientsCSV, newelement],
      counter: prevState.counter + 1,
    }));
  };

  visitsPrePro() {
    this.setState({
      sheet: [],
      acupunctureSheet: [],
      osteopathySheet: [],
      massageSheet: [],
      herbsSheet: [],
      productsSheet: [],
      otherSheet: [],
    });
    // // console.log("all visits", this.props.visits);
    const countedVisits = this.props.visits.filter(function (visit) {
      return !visit.blocked && visit.service[0].paid && !visit.noshow;
    });
    // prep all visits for download
    // // console.log("counted Visits", countedVisits);
    countedVisits.forEach((visit) => {
      visit.service.forEach((service) => {
        let formattedItem = [
          visit._id,
          visit.patient.id,
          visit.patient.name,
          String(visit.date.start),
          service.practitioner.name,
          service.type,
          service.price.gross,
          service.price.tax,
          service.price.net,
          service.paid,
          service.invoice.yn,
        ];
        if (service.type === "Acupuncture") {
          this.setState((prevState) => ({
            acupunctureSheet: [...prevState.acupunctureSheet, formattedItem],
          }));
        } else if (service.type === "Osteopathy") {
          this.setState((prevState) => ({
            osteopathySheet: [...prevState.osteopathySheet, formattedItem],
          }));
        } else if (service.type === "Massage") {
          this.setState((prevState) => ({
            massageSheet: [...prevState.massageSheet, formattedItem],
          }));
        } else if (service.type === "Herbs") {
          this.setState((prevState) => ({
            herbsSheet: [...prevState.herbsSheet, formattedItem],
          }));
        } else if (service.type === "Products") {
          this.setState((prevState) => ({
            productsSheet: [...prevState.productsSheet, formattedItem],
          }));
        } else {
          this.setState((prevState) => ({
            otherSheet: [...prevState.otherSheet, formattedItem],
          }));
        }
        this.setState((prevState) => ({
          sheet: [...prevState.sheet, formattedItem],
        }));

        // this.setState({
        //     sheet: this.state.sheet.concat(
        //         []
        //     )
        // });
        // // console.log("hit")
      });
    });
  }

  patientsPrePro = new Promise((resolve, reject) => {
    this.setState({
      sheetPat: [],
    });
    // prep all visits for download
    this.props.patients.forEach((patient) => {
      let formattedItem = [
        patient.intake.general.firstName +
          " " +
          patient.intake.general.lastName,
        patient.intake.general.addressStreet +
          ", " +
          patient.intake.general.addressCity +
          ", " +
          patient.intake.general.addressPostal,
        patient.intake.general.cellPhone,
        patient.intake.general.email,
      ];

      this.setState((prevState) => ({
        sheetPat: [...prevState.sheetPat, formattedItem],
      }));
    });
  }, Promise.resolve());

  // patientsPrePro() {
  //     this.setState({
  //         sheetPat: [],
  //     })
  //     // prep all visits for download
  //     // console.log("patient props", this.props.patients)
  //     this.props.patients.forEach(
  //         patient => {
  //             let formattedItem = [
  //                 patient.intake.general.firstName + " " + patient.intake.general.lastName,
  //                 patient.intake.general.addressStreet + ", " + patient.intake.general.addressCity + ", " + patient.intake.general.addressPostal,
  //                 patient.intake.general.cellPhone,
  //                 patient.intake.general.email,
  //             ]

  //             this.setState(prevState => ({
  //                 sheetPat: [...prevState.sheetPat, formattedItem]
  //             }))

  //         }
  //     ).then(() => { this.csvLink.current.link.click() })
  //     // console.log("this.state.sheetPat", this.state.sheetPat);

  // }

  componentDidMount() {
    document.title = "Patients | Appleby Wellness";
    this.props.fetchPatients(); //.then(() => {this.patientsPrePro()})
    this.props.fetchVisits(); //.then(() => {this.visitsPrePro()})
  }

  componentWillReceiveProps(nextState) {
    // console.log("next state", nextState.visits);
    this.setState({
      patients: nextState.patients,
      visits: nextState.visits,
    });
  }

  handleDownload = () => {
    // console.log(this.state.sheet);
    // console.log(this.state.acupunctureSheet);
  };

  handleDownloadPatients = () => {
    this.patientsPrePro().then(() => {
      this.csvLink.current.link.click();
    });
  };

  // The single source of truth for "which visits become spreadsheet rows".
  // Kept identical to the filter in visitsToExcelConversion so the count shown
  // on the Download button always matches the number of rows written.
  isDownloadableVisit = (visit) =>
    !!visit &&
    !visit.blocked &&
    Array.isArray(visit.service) &&
    visit.service[0] &&
    visit.service[0].paid &&
    !visit.noshow;

  openDownloadModal = () => {
    const { start, end } = DEFAULT_DOWNLOAD_RANGE();
    this.setState(
      {
        open: false, // close the speed dial behind the modal
        downloadModalOpen: true,
        selectedPreset: "custom", // the default range matches no preset
        rangeStart: start,
        rangeEnd: end,
        previewVisits: [],
        previewCount: 0,
        previewError: null,
      },
      this.loadPreview
    );
  };

  closeDownloadModal = () => {
    this.setState({ downloadModalOpen: false });
  };

  selectPreset = (key) => {
    const preset = DOWNLOAD_PRESETS.find((p) => p.key === key);
    if (!preset) return;
    const { start, end } = preset.range();
    this.setState(
      { selectedPreset: key, rangeStart: start, rangeEnd: end },
      this.loadPreview
    );
  };

  handleRangeStartChange = (date) => {
    if (!date || !date.isValid()) return;
    this.setState(
      (prev) => ({
        rangeStart: date,
        // Keep end on/after start so the range stays valid.
        rangeEnd:
          prev.rangeEnd && prev.rangeEnd.isBefore(date)
            ? date.clone()
            : prev.rangeEnd,
        selectedPreset: "custom",
      }),
      this.loadPreview
    );
  };

  handleRangeEndChange = (date) => {
    if (!date || !date.isValid()) return;
    this.setState({ rangeEnd: date, selectedPreset: "custom" }, this.loadPreview);
  };

  // Fetch the visits for the chosen range (without touching the Redux store) and
  // compute how many would be written to the sheet. A monotonically increasing
  // request id guards against an earlier, slower response overwriting a newer
  // one when the user changes the range quickly.
  //
  // The Download button is deliberately NOT put into a loading state here: the
  // previous count stays on screen until the new one arrives, so switching
  // presets updates the number in place instead of flashing through a spinner.
  loadPreview = () => {
    const { rangeStart, rangeEnd } = this.state;
    if (!rangeStart || !rangeEnd) return;

    const requestId = (this._previewRequestId || 0) + 1;
    this._previewRequestId = requestId;

    if (this.state.previewError) this.setState({ previewError: null });

    const start = rangeStart.clone().format("YYYY-MM-DD");
    // The endpoint's upper bound is exclusive, so send the day after the chosen
    // last day.
    const endExclusive = rangeEnd.clone().add(1, "day").format("YYYY-MM-DD");

    fetchVisitsForExport(start, endExclusive)
      .then((data) => {
        if (this._previewRequestId !== requestId) return; // superseded
        const startDay = rangeStart.clone().startOf("day");
        const endDay = rangeEnd.clone().endOf("day");
        const inRange = (data || []).filter((visit) => {
          const when = moment(visit.date && visit.date.start);
          return (
            when.isValid() &&
            when.isSameOrAfter(startDay) &&
            when.isSameOrBefore(endDay)
          );
        });
        this.setState({
          previewVisits: inRange,
          previewCount: inRange.filter(this.isDownloadableVisit).length,
        });
      })
      .catch((error) => {
        if (this._previewRequestId !== requestId) return;
        this.setState({
          previewError: error,
          previewVisits: [],
          previewCount: 0,
        });
      });
  };

  handleDownloadSelected = () => {
    // Build and download the spreadsheet from the range-selected visits; the
    // existing conversion + <ExcelFile> path is unchanged, so the file is too.
    this.getVisitData(this.state.previewVisits);
    this.setState({ downloadModalOpen: false });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  handleOpen = () => {
    this.setState({
      open: true,
    });
    // // console.log(this.state.sheetPat);
    // // console.log(this.props.visits);
    // if (this.state.sheetPat) {
    //     // console.log("hit")
    //     this.patientsPrePro()
    // }
    // if(!this.props.visits){
    //     this.visitsPrePro()
    // }
  };

  routeChangePatient = (id) => {
    const { history } = this.props;
    history.push("patient/" + id);
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        {this.props.admin.permissions === "Administrator" ||
        this.props.admin.permissions === "Developer" ? (
          <ThemeProvider theme={theme}>
            <Grid
              container
              direction="row-reverse"
              justify="flex-start"
              alignItems="center"
            >
              <Grid item>
                <Autocomplete
                  id="searchAuto"
                  size="small"
                  options={this.props.patients}
                  getOptionLabel={(option) =>
                    option.intake.general.firstName +
                    " " +
                    option.intake.general.lastName
                  }
                  renderOption={(option) => (
                    <React.Fragment>
                      <div>
                        <Typography variant="body1">
                          {option.intake.general.firstName +
                            " " +
                            option.intake.general.lastName}
                        </Typography>
                        <Typography variant="caption">
                          {option.intake.general.cellPhone}
                        </Typography>
                      </div>
                    </React.Fragment>
                  )}
                  style={{ width: 250 }}
                  renderInput={(params) => (
                    <TextField {...params} label="Search" variant="outlined" />
                  )}
                  onChange={(event, newValue) =>
                    this.handleSearchChange(newValue)
                  }
                  value={this.state.search}
                />
              </Grid>
            </Grid>
            <hr
              style={{
                borderTopColor: "#cccccc",
                borderTop: 1,
                marginTop: 40,
                marginBottom: 40,
              }}
            />

            <Grid
              container
              justify="left"
              spacing={5}
              style={{ paddingLeft: 70, paddingRight: 70 }}
            >
              {this.state.patients
                .sort((a, b) =>
                  a.intake.general.firstName.localeCompare(
                    b.intake.general.firstName
                  )
                )
                .map((patient) => (
                  <Grid key={patient._id} item>
                    <Card className={classes.root} variant="outlined">
                      <CardContent>
                        <Typography
                          variant="overline"
                          style={{ fontSize: 14 }}
                          color="textSecondary"
                          gutterBottom
                        >
                          patient
                        </Typography>
                        <Typography variant="h5" component="h2">
                          {patient.intake.general.firstName}{" "}
                          {patient.intake.general.lastName}
                        </Typography>
                        <Typography
                          style={{ marginBottom: 12 }}
                          color="textSecondary"
                        >
                          {patient.intake.general.cellPhone}
                        </Typography>
                        {/* <Typography variant="body2" component="p">
                                            well meaning and kindly.
                                            <br />
                                            {'"a benevolent smile"'}
                                        </Typography> */}
                      </CardContent>
                      <CardActions>
                        <Button
                          onClick={this.routeChangePatient.bind(
                            this,
                            patient._id
                          )}
                          size="small"
                        >
                          Visit Profile
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid>
                ))}
            </Grid>
            <div className={classes.exampleWrapper}>
              <SpeedDial
                ariaLabel="SpeedDial"
                className={classes.speedDial}
                hidden={false}
                icon={<SpeedDialIcon />}
                onClose={this.handleClose}
                onOpen={this.handleOpen}
                open={this.state.open}
                direction={"up"}
              >
                {/* {this.state.actions.map(action => ( */}
                <SpeedDialAction
                  key={"Download Visits"}
                  icon={<SaveIcon style={{ marginTop: 4 }} />}
                  tooltipTitle={"Download Visits"}
                  FabProps={{ "aria-label": "Download Visits" }}
                  onClick={this.openDownloadModal}
                />
                <SpeedDialAction
                  key={"Download Patients"}
                  icon={
                    <AssignmentIcon style={{ marginTop: 6 }} />

                    // <ExcelFile filename="Patients" element={}>
                    //     <ExcelSheet dataSet={
                    //         [{
                    //             columns: this.state.columnsPat,
                    //             data: this.state.sheetPat,
                    //         }]
                    //     } name="All Patients" />
                    // </ExcelFile>
                  }
                  tooltipTitle={"Download Patients"}
                  onClick={this.getPatientData}
                />
                <SpeedDialAction
                  key={"This Week's Payroll"}
                  icon={<AccountBalanceWalletIcon style={{ marginTop: 4 }} />}
                  tooltipTitle={"This Week's Payroll"}
                  onClick={this.getPractitionerWeekData}
                />
                {/* ))} */}
              </SpeedDial>
              <Dialog
                open={this.state.downloadModalOpen}
                onClose={this.closeDownloadModal}
                maxWidth="xs"
                fullWidth
                aria-labelledby="download-visits-title"
              >
                <DialogTitle id="download-visits-title">
                  Download Visits
                </DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Choose which visits to include in the spreadsheet.
                  </DialogContentText>
                  <Grid
                    container
                    spacing={1}
                    style={{ marginTop: 8, marginBottom: 8 }}
                  >
                    {DOWNLOAD_PRESETS.map((preset) => (
                      <Grid item key={preset.key}>
                        <Button
                          variant={
                            this.state.selectedPreset === preset.key
                              ? "contained"
                              : "outlined"
                          }
                          color="primary"
                          size="small"
                          onClick={() => this.selectPreset(preset.key)}
                        >
                          {preset.label}
                        </Button>
                      </Grid>
                    ))}
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <KeyboardDatePicker
                        fullWidth
                        disableToolbar
                        autoOk
                        variant="inline"
                        format="YYYY-MM-DD"
                        margin="normal"
                        id="download-start-date"
                        label="Start Date"
                        value={this.state.rangeStart}
                        onChange={this.handleRangeStartChange}
                        KeyboardButtonProps={{
                          "aria-label": "change start date",
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <KeyboardDatePicker
                        fullWidth
                        disableToolbar
                        autoOk
                        variant="inline"
                        format="YYYY-MM-DD"
                        margin="normal"
                        id="download-end-date"
                        label="End Date"
                        minDate={this.state.rangeStart}
                        value={this.state.rangeEnd}
                        onChange={this.handleRangeEndChange}
                        KeyboardButtonProps={{
                          "aria-label": "change end date",
                        }}
                      />
                    </Grid>
                  </Grid>
                  {this.state.previewError && (
                    <Typography color="error" variant="caption">
                      Could not load visits for this range. Please try again.
                    </Typography>
                  )}
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.closeDownloadModal}>Cancel</Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleDownloadSelected}
                    disabled={this.state.previewCount === 0}
                    startIcon={<SaveIcon />}
                  >
                    {`Download ${this.state.previewCount} Visits`}
                  </Button>
                </DialogActions>
              </Dialog>
              <CSVLink
                data={this.state.patientsCSV}
                headers={this.state.columnsPat}
                filename="patients.csv"
                className="hidden"
                ref={this.csvLink}
                target="_blank"
              />
              {this.state.downloadReady && (
                <ExcelFile
                  filename="Patient Visits"
                  className="hidden"
                  hideElement="true"
                  ref={this.ExcelLink}
                >
                  <ExcelSheet
                    dataSet={[
                      {
                        columns: this.state.columns,
                        data: this.state.sheet,
                      },
                    ]}
                    name="Summary"
                  />
                  <ExcelSheet
                    dataSet={[
                      {
                        columns: this.state.columns,
                        data: this.state.acupunctureSheet,
                      },
                    ]}
                    name="Acupuncture"
                  />
                  <ExcelSheet
                    dataSet={[
                      {
                        columns: this.state.columns,
                        data: this.state.osteopathySheet,
                      },
                    ]}
                    name="Osteopathy"
                  />
                  <ExcelSheet
                    dataSet={[
                      {
                        columns: this.state.columns,
                        data: this.state.massageSheet,
                      },
                    ]}
                    name="Massage"
                  />
                  <ExcelSheet
                    dataSet={[
                      {
                        columns: this.state.columns,
                        data: this.state.herbsSheet,
                      },
                    ]}
                    name="Herbs"
                  />
                  <ExcelSheet
                    dataSet={[
                      {
                        columns: this.state.columns,
                        data: this.state.productsSheet,
                      },
                    ]}
                    name="Products"
                  />
                  <ExcelSheet
                    dataSet={[
                      {
                        columns: this.state.columns,
                        data: this.state.otherSheet,
                      },
                    ]}
                    name="Other"
                  />
                </ExcelFile>
              )}

              {this.state.downloadPayrollReady && (
                <ExcelFile
                  filename="Practitioner Payroll"
                  className="hidden"
                  hideElement="true"
                  ref={this.ExcelLinkPayroll}
                >
                  <ExcelSheet
                    dataSet={[
                      {
                        columns: this.state.columns,
                        data: this.state.payroll_one,
                      },
                    ]}
                    name={
                      this.props.admins[0]
                        ? this.props.admins[0].name
                        : "Empty Practitioner 0"
                    }
                  />
                  <ExcelSheet
                    dataSet={[
                      {
                        columns: this.state.columns,
                        data: this.state.payroll_two,
                      },
                    ]}
                    name={
                      this.props.admins[1]
                        ? this.props.admins[1].name
                        : "Empty Practitioner 1"
                    }
                  />
                  <ExcelSheet
                    dataSet={[
                      {
                        columns: this.state.columns,
                        data: this.state.payroll_three,
                      },
                    ]}
                    name={
                      this.props.admins[2]
                        ? this.props.admins[2].name
                        : "Empty Practitioner 2"
                    }
                  />
                  <ExcelSheet
                    dataSet={[
                      {
                        columns: this.state.columns,
                        data: this.state.payroll_four,
                      },
                    ]}
                    name={
                      this.props.admins[3]
                        ? this.props.admins[3].name
                        : "Empty Practitioner 3"
                    }
                  />
                  <ExcelSheet
                    dataSet={[
                      {
                        columns: this.state.columns,
                        data: this.state.payroll_five,
                      },
                    ]}
                    name={
                      this.props.admins[4]
                        ? this.props.admins[4].name
                        : "Empty Practitioner 4"
                    }
                  />
                  <ExcelSheet
                    dataSet={[
                      {
                        columns: this.state.columns,
                        data: this.state.payroll_six,
                      },
                    ]}
                    name={
                      this.props.admins[5]
                        ? this.props.admins[5].name
                        : "Empty Practitioner 5"
                    }
                  />
                  <ExcelSheet
                    dataSet={[
                      {
                        columns: this.state.columns,
                        data: this.state.payroll_seven,
                      },
                    ]}
                    name={
                      this.props.admins[6]
                        ? this.props.admins[6].name
                        : "Empty Practitioner 6"
                    }
                  />
                  <ExcelSheet
                    dataSet={[
                      {
                        columns: this.state.columns,
                        data: this.state.payroll_eight,
                      },
                    ]}
                    name={
                      this.props.admins[7]
                        ? this.props.admins[7].name
                        : "Empty Practitioner 7"
                    }
                  />
                  <ExcelSheet
                    dataSet={[
                      {
                        columns: this.state.columns,
                        data: this.state.payroll_nine,
                      },
                    ]}
                    name={
                      this.props.admins[8]
                        ? this.props.admins[8].name
                        : "Empty Practitioner 8"
                    }
                  />
                  <ExcelSheet
                    dataSet={[
                      {
                        columns: this.state.columns,
                        data: this.state.payroll_ten,
                      },
                    ]}
                    name={
                      this.props.admins[9]
                        ? this.props.admins[9].name
                        : "Empty Practitioner 9"
                    }
                  />
                </ExcelFile>
              )}
            </div>
          </ThemeProvider>
        ) : (
          <div> There is no content on this page. </div>
        )}
      </div>
    );
  }
}

// function matchDispatchToProps(dispatch) {
//     return bindActionCreators({ submitLogin: submitLogin, isLoggedIn: isLoggedIn },
//         dispatch);
// }

function mapStateToProps(state) {
  return {
    patients: state.patients,
    visits: state.visits,
    admins: state.admins,
    admin: state.admin,
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    fetchVisits,
    fetchPatients,
    fetchAdmins,
  })
)(withRouter(Patients));
